import ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux'
import store from './store/store'
import reportWebVitals from './reportWebVitals'
import './index.css'
import {ChakraProvider, extendTheme} from '@chakra-ui/react'
import {AuthProvider} from '@hooks/useAuth'
import './font'
import {datadogRum} from '@datadog/browser-rum'
import TrackingPage from '@components/TrackingPage'
import {getUserId, isFacebookInAppBrowser} from '@utils'
import {LOCAL_STORAGE, SESSION_STORAGE} from '@utils/Const'
import appRequest from '@apis/app'
import Layout from '@pages/Layout'

const urlParams = new URLSearchParams(window.location.search)
const userIdOnUrl = urlParams.get(LOCAL_STORAGE.USER_ID)

if (userIdOnUrl && (!getUserId() || getUserId() === 'undefined')) {
  localStorage.setItem(LOCAL_STORAGE.USER_ID, userIdOnUrl)
}

if (getUserId() && getUserId() !== 'undefined') {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATA_DOG_ID || '',
    clientToken: process.env.REACT_APP_DATA_DOG_TOKEN || '',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'us5.datadoghq.com',
    service: `ielts-${process.env.REACT_APP_ENV}`,
    env: process.env.REACT_APP_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

  datadogRum.setUser({
    id: getUserId() || 'missing_2',
  })
} else if (getUserId() === 'undefined') {
  localStorage.removeItem(LOCAL_STORAGE.USER_ID)
  localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN)
  localStorage.removeItem(LOCAL_STORAGE.REFRESH_TOKEN)

  const initApp = async () => {
    const params: any = {}
    const utmSource = urlParams.get(SESSION_STORAGE.UTM_SOURCE)
    const utmMedium = urlParams.get(SESSION_STORAGE.UTM_MEDIUM)
    const utmCampaign = urlParams.get(SESSION_STORAGE.UTM_CAMPAIGN)
    const referralUserId = urlParams.get('u')
    const referralAgent = urlParams.get('agt')

    if (utmSource) params.utm_source = utmSource
    if (utmMedium) params.utm_medium = utmMedium
    if (utmCampaign) params.utm_campaign = utmCampaign
    if (referralUserId) params.ref_user_id = referralUserId
    if (referralAgent) params.ref_agent_id = referralAgent
    const res = await appRequest.init(params)
    const userId = res?.data?.data?.user_id
    localStorage.setItem(LOCAL_STORAGE.USER_ID, userId)
    if (isFacebookInAppBrowser()) {
      if (userId) {
        const newUrl = new URL(window.location.href)
        newUrl.searchParams.set(LOCAL_STORAGE.USER_ID, userId)
        window.history.replaceState({}, '', newUrl)
      }
    }
  }

  initApp()
}

const theme = extendTheme({
  fonts: {
    heading: 'Inter, serif',
    body: 'Inter, serif',
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <AuthProvider>
        <Layout />
        <TrackingPage />
      </AuthProvider>
    </ChakraProvider>
  </Provider>,
  // </React.StrictMode>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
